<script>
import $ from "jquery"

export default {
  data() {
   return {
     videos: [],
     favoriteVideos: []
   };
  },
  mounted() {
    this.$on('addFavoriteVideo', this.addFavoriteVideo)
    this.$on('removeFavoriteVideo', this.removeFavoriteVideo)
    this.$on('downloadVideo', this.downloadVideo)
  },
  methods:  {
    addFavoriteVideo(video) {
      this.favoriteVideos.push(video)
    },
    removeFavoriteVideo(video) {
      var _this = this;
      $(this.favoriteVideos).each(function(index, el) {
        if(el.id == video.id) {
          _this.favoriteVideos.splice(index, 1)
        }
      });
    },
    downloadVideo(video) {
      this.$http({
        method: 'get',
        url: video.url,
        responseType: 'arraybuffer'
      }).then(response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', video.video_file_name);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    }
  },
  computed: {
    hasVideos() {
      return this.videos.length > 0;
    }
  }
}
</script>
